const suppliers = {
  toast: {
    error: {
      badResponse: '[Supplier] bad server response',
      create: {},
      edit: {},
    },
    success: {
      create: {
        default: '[Supplier] has been created successfully',
      },
      edit: {},
    },
  },
  createNew: 'Create',
  updateRanking: 'Update Ranking',
  table: {
    headers: {
      name: 'Name',
      rank: 'Rank',
      tier: 'Tier',
      overallScore: 'Overall Score',
      onTimePerformance: 'On Time %',
      noShowRate: 'No Show %',
      cancellationsRate: 'Cancellations Rate %',
      acceptanceRate: 'Acceptance Rate %',
      avgResponseTime: 'Avg Response Time',
      complaints: 'Complaints',
      vehicles: 'Vehicles',
      supplierStatus: 'Status',
    },
    actions: {
      delete: 'Delete',
      export: 'Export',
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission required',
    },
  },
  create: {
    successToast: {
      message: 'Success! Supplier Created!',
    },
    errorToast: {
      message: 'Error occurred. Could Not Create Supplier',
    },
  },
  edit: {
    successToast: {
      message: 'Success! Supplier Updated!',
    },
    errorToast: {
      message: 'Error occurred. Could Not Update Supplier',
    },
  },
  deleteModal: {
    header: 'Delete Suppliers',
    body: 'You are about to delete {{num}} suppliers.',
  },
  deleteToast: "Can't delete suppliers",
  forms: {
    header: {
      createSupplier: {
        title: 'Create',
      },

      updateSupplier: {
        title: 'Update',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Submit',
        update: 'Submit',
      },
    },

    information: {
      rank: {
        header: 'Supplier Rank and Score',
        fields: {
          rank: 'Rank {{rank}}',
          score: 'Score: ',
        },
      },
      generalInformation: {
        header: 'General Information',
        fields: {
          name: 'Name',
          status: 'Status',
          tier: 'Tier',
          tierAndScore: 'Supplier Tier and Score',
          statusOptions: {
            select: 'Select',
            active: 'Active',
            inactive: 'Inactive',
          },
        },
      },
      supplierKpis: {
        header: 'Supplier KPIs',
        fields: {
          onTimePerformance: 'On Time Performance (%)',
          noShowRate: 'No-Show Rate (%)',
          cancellationsRate: 'Cancellations Rate (%)',
          acceptanceRate: 'Acceptance Rate (%)',
          avgResponseTime: 'Avg. Response Time (min)',
          complaints: 'Complaints',
        },
      },
      advancedSettings: {
        header: 'Advanced Settings',
        fields: {
          areas: 'Zones',
          attributes: 'Attributes',
          excludedAttributes: 'Excluded Attributes',
          minTrips: 'Min Trips',
          maxTrips: 'Max Trips',
          allowDecline: 'Allow Decline',
          allowSharedRides: 'Allow Shared Rides',
          weekDays: 'WeekDays Availability',
        },
      },
      contactInformation: {
        header: 'Contact Information',
        fields: {
          name: 'Name',
          type: 'Type',
          phone: 'Phone',
          email: 'Email',
          address: 'Address',
          comment: 'Comment',
          btnAddContact: 'Add Contact +',
        },
      },
      notes: {
        header: 'Notes',
        fields: {
          notes: 'Notes',
        },
      },
      vehiclesTable: {
        cells: {
          name: 'Name',
          seats: 'Seats',
          attributes: 'Attributes',
        },
      },
    },
    select: 'Select',
  },
  delete: {
    confirmation: {
      header: 'Delete supplier confirmation',
      body: 'Suppliers were deleted successfully',
    },
  },
};

export default suppliers;
